<div class="container">
  <div class="col-lg-12">
    <div class="row">
      <div class="offset-lg-3 col-lg-6">
        <div class="card mt-5">
          <div class="card-header cheader">
            Latest Account Details
          </div>
          <div class="card-body">
            <div class="form-horizontal" *ngIf="serviceType=='beforeResponse'">
              <!-- Text input-->
              <div class="form-group">
                <div class="col-md-12">
                  <label class="col-md-12 control-label" for="textinput1">Current Branch</label>
                  <input [(ngModel)]="presentbrnch" id="textinput1" name="textinput" type="text"
                    placeholder="Current Branch." class="form-control input-md" readonly>
                </div>
              </div>

              <!-- Text input-->
              <div class="form-group">
                <div class="col-md-12">
                  <label class="col-md-12 control-label" for="textinput2">Account Number</label>
                  <input [(ngModel)]="account_no" id="textinput2" name="textinput" type="text"
                    placeholder="Account Number" class="form-control input-md" readonly>
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-12">
                  <label class="col-md-12 control-label" for="textinput1">Reason</label>
                  <input [(ngModel)]="reason" id="textinput3" name="textinput" type="text"
                    placeholder="Reason For Sol Change" class="form-control input-md"
                    (ngModelChange)="disableGenerateButton()" maxlength="100" autocomplete="off" >
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-12">
                  <label class="col-md-12 control-label" for="SelectBox">Select New Branch</label> 
                  <ng-select [items]="sol_list" placeholder="Select New Branch" bindLabel="BRANCH_NAME"
                    bindValue="SOL_ID" [(ngModel)]="selectedsol" (ngModelChange)="getCustConfirmMsg()">
                  </ng-select>
                </div>
              </div>
              <div class="form-group" *ngIf="servicemsg=='afterResponse'">
                <div class="col-md-12">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                      [(ngModel)]="txtcheckbox" (ngModelChange)="disableGenerateButton()">
                    <label class="form-check-label" for="flexCheckDefault" style="font-size: small;">
                      {{terms}}
                    </label> <span class="text-primary" style="cursor: pointer;font-size: small;"
                      (click)="goToLink()">(Click here for new scheme related details)</span>
                    <br />
                    <label class="form-check-label" for="flexCheckDefault" style="font-size: small;">
                      I hereby confirm having read and understood the new scheme details including the minimum balance
                      to be maintained by me in my account and applicable service charges pursuant to account scheme
                      change and I acknowledge/accept the same. I also undertake to submit a request to the Bank for new
                      cheque book at the earliest owing to the change in branch name , IFSC code etc.
                    </label>
                  </div>
                </div>
              </div>
              <!-- submit button -->
              <div class="form-group ">
                <!-- <label class="col-md-12 control-label" for="passwordinput">Password Input</label> -->
                <div class="col-md-12 ">
                  <button (click)="changesolfunc()" class="btn btn-info btn-block"
                    [disabled]="isDisabled">Submit</button>
                </div>
              </div>
            </div>
          </div>
          <div class="form-horizontal" *ngIf="serviceType=='afterResponse'">
            <div class="form-group ">
              <div class="col-md-12 ">
                <label [ngClass]="label_class">{{update_response}}</label>
                <a href="https://accountopen.federalbank.co.in/CustomerPortal/index">Back Home</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">Please Wait. </p>
</ngx-spinner>